<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-settings-zones"
      :title="$t(titleModal)"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      size="lg"
      no-close-on-backdrop
    >
      <ValidationObserver ref="form-validation">
        <b-row>
          <!-- ZONE NAME -->
          <b-col cols="6">
            <ValidationProvider
            v-slot="{ errors }"
            rules="required|max:100"
            name="zone_name"
            >
              <b-form-group 
              :label="$t('Zone name')"
              :state="errors[0] ? false : null"
              >
                <b-form-input
                type="text"
                v-model="form.zoneName"                
                :class="{ 'border-danger': errors[0] }"
                @change="verifyDuplicated('name')"
                ></b-form-input>
                <span v-if="errors[0]" class="text-danger">
                  Zone {{ errors[0] }}
                </span>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col cols="6">
            <ValidationProvider
            v-slot="{ errors }"
            rules="required|max:4"
            name="code"
            >
              <b-form-group 
              :label="$t('Code')"
              :state="errors[0] ? false : null"
              >
                <b-form-input
                type="text"
                v-model="form.code"
                :class="{ 'border-danger': errors[0] }"
                @change="verifyDuplicated('code')"
                ></b-form-input>
                <span v-if="errors[0]" class="text-danger">
                  Code {{ errors[0] }}
                </span>
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <!-- DEPARTMENT -->
          <b-col cols="4">
            <b-form-group :label="$t('Department')">
              <v-select
              v-model="deptSelected"
              :options="departments"
              :reduce="(val) => val.id"
              label="name"
              @input="changeDept"
              ></v-select>
            </b-form-group>
          </b-col>

          <!-- PROVINCE -->
          <b-col cols="4">
            <b-form-group :label="$t('Province')">
              <v-select
              v-model="provSelected"
              :options="provinces"
              :reduce="(val) => val.id"
              label="name"
              :disabled="deptSelected == null"
              @input="changeProv"
              ></v-select>
            </b-form-group>
          </b-col>

          <!-- DISTRICT -->
          <b-col cols="4">
            <b-form-group :label="$t('District')">
              <v-select
              v-model="distSelected"
              :options="districts"
              :reduce="(val) => val.id"
              label="name"
              :disabled="provSelected == null"
              @input="changeDist"
              ></v-select>
            </b-form-group>
          </b-col>

          <!-- SELECTEDS -->
          <b-col cols="12">
            <div class="overflow-auto" style="height: 300px">
              <div
                v-for="(dist, index) in form.distSelectedList"
                :key="dist.id"         
                class="mt-1 border-bottom row justify-content-between overflow-auto"
              >
                <div class="ml-2 mr-2">
                  <b-avatar size="sm" rounded variant="light-success" />
                  <span>
                    {{ dist.name }}
                  </span>
                </div>
                <feather-icon
                  icon="DeleteIcon"
                  size="20"
                  class="text-danger mr-2 cursor-pointer"
                  @click="deleteItem(dist, index)"
                />
              </div>
            </div>
          </b-col>
        </b-row>
      </ValidationObserver>
      <template #modal-footer>
        <b-container fluid>
          <b-row>
            <b-col class="d-flex align-items-center justify-content-end p-0">
              <b-button
                class="mr-1"
                @click="$emit('hideModal', false)"
                v-t="'CANCEL'"
              >
              </b-button>
              <b-button :disabled="form.distSelectedList == 0" variant="primary" @click="save">
                {{ $t(titleButton) }}
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
  </div>
</template>

<script>
/* Service */
import TravelRoutesService from "@/views/settings/views/travel-routes/services/travel-routes.service.js";
import { mapGetters } from "vuex"
export default {
  components: {},
  data() {
    return {
      items: [],
      form: {
        zoneName: null,
        distSelectedList: [],
        code: null
      },
      roles: [],
      rolSelected: null,
      departments: [],
      provinces: [],
      districts: [],
      deptSelected: null,
      provSelected: null,
      distSelected: null,
      distDeleteList: [],
      districtsBckp: [],
    };
  },
  props:{
    zoneId:{
      type: Number,
      default: null
    }
  },
  mounted() {
    this.toggleModal("modal-settings-zones");
  },
  async created() {    
    this.addPreloader();
    try {
      if(this.zoneId != null){
        await this.getZoneData();
      }
      await this.getDepartments();
    } catch (error) {
      this.showToastError("Proceso fallido", "Error")
    } finally {
      this.removePreloader(); 
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser"
    }),
    titleModal() {
      return this.zoneId == null ? "NEW ZONE" : "EDIT ZONE";
    },
    titleButton(){
      return this.zoneId == null ? "SAVE" : "UPDATE";
    }
  },
  methods: {
    async changeDept(val){
      this.distSelected = null;
      this.provSelected = null;
      await this.getProvinces(val)
    },
    async changeProv(val){
      this.distSelected = null;
      await this.getDistricts(val)
    },
    async changeDist(val){
      const dist = this.districts.filter(dist => dist.id == val);
      this.form.distSelectedList.push(dist[0]);
      this.resetList(val)
    },
    resetList(){
      this.districts = this.districtsBckp.filter(dist => {
        return !this.form.distSelectedList.some(dist2 => dist2.id === dist.id);
      });
      this.distSelected = null;
    },
    async save(){
      const validate = await this.$refs["form-validation"].validate();
      if(validate){
        const params = {
          "zoneId": this.zoneId,
          "zoneName": this.form.zoneName,
          "code": this.form.code,
          "distSelecteds": this.form.distSelectedList.filter(dist => dist.saved == undefined),
          "distDeleted": this.distDeleteList,
          "user_id": this.currentUser.employee_id
        }

        const { data } = await TravelRoutesService.save(params);
        if(data.success){
          this.showToastSuccess("Proceso exitoso", "Exito")
          this.$emit("refreshTable");
          this.$emit("hideModal");
        }else{
          this.showToastError("Proceso fallido", "Error")
        }
      }
    },
    async getZoneData(){
      const params = {
        id: this.zoneId
      }
      const { zoneName, code, distSelectedList } = await TravelRoutesService.getZoneData(params);
      this.form = { zoneName, code, distSelectedList: JSON.parse(distSelectedList) }
    },
    async getDepartments(){
      const { data } = await TravelRoutesService.getDepartments();
      this.departments = data;
    },
    async getProvinces(id){
      const { data } = await TravelRoutesService.getProvinces(id);
      this.provinces = data;
    },
    async getDistricts(id){
      const { data } = await TravelRoutesService.getDistricts(id);
      this.districtsBckp = data;
      this.districts = data;
    },
    deleteItem(dist, index){
      if(dist.saved){
        this.distDeleteList.push(dist);
      }
      this.form.distSelectedList.splice(index, 1);
      this.resetList();
    },
    async verifyDuplicated(model){
      const params = {
        model: model,
        value: model == 'name' ? this.form.zoneName : this.form.code
      }
      const { data } = await TravelRoutesService.verifyDuplicated(params);
      if(data.is_duplicated){
        this.showToastWarning("El dato ingresado fue registrado anteriormente", "Oops...")
        if(model == 'name'){
          this.form.zoneName = null;
        }else{
          this.form.code = null;
        }
      }
    },
    hideModal(){
      this.$emit("hideModal");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>